/**
 * 運搬ルート
 */
import * as httpConst from '../../../../constants/httpConst'
import * as types from '../../../mutation-types/admin-types'
import Vue from 'vue'

const API_PATH = `${httpConst.ADMIN_ENDPOINT}/masters/transport_routes`

 const master_transport_routes = {
   namespaced: true,
   actions: {
    index ({ commit }, { id }) {
      const api_path = `${API_PATH}/?trader_id=${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
  },
 }

 export default master_transport_routes
